<template>
    <table class="datatable">
        <caption class="caption">Audit log list table</caption>
        <tr>
            <th scope="col">{{ $t("admin.adminAuditLogList.table.timestamp") }}</th>
            <th scope="col">{{ $t("admin.adminAuditLogList.table.action") }}</th>
            <th scope="col">{{ $t("admin.adminAuditLogList.table.actor") }}</th>
            <th scope="col">{{ $t("admin.adminAuditLogList.table.objects") }}</th>
            <th scope="col">{{ $t("admin.adminAuditLogList.table.data") }}</th>
        </tr>
        <tr v-for="(al, index) in listing" v-bind:key="index">
            <td style="vertical-align: top;">{{ new Date(al.createdTimestamp).toLocaleString() }}</td>
            <td style="vertical-align: top;">{{ al.action }}</td>
            <td style="vertical-align: top;">
                <span v-if="al.actorId">
                    <router-link :to="'/admin/userView/' + al.actorId">{{al.actorEmailAddress}}</router-link>
                </span>
            </td>
            <td style="vertical-align: top;">
                <span v-if="al.planId"><router-link :to="'/admin/planView/' + al.planId">Plan: {{al.planName}}</router-link><br/></span>
                <span v-if="al.groupId"><router-link :to="'/admin/groupView/' + al.groupId">Group: {{al.groupName}}</router-link><br/></span>
                <span v-if="al.projectId"><router-link :to="'/admin/projectView/' + al.projectId">Project: {{al.projectName}}</router-link><br/></span>
                <span v-if="al.appUserId"><router-link :to="'/admin/userView/' + al.appUserId">User: {{al.appUserEmailAddress}}</router-link><br/></span>
            </td>
            <td style="vertical-align: top;"><pre>{{ JSON.stringify(JSON.parse(al.data), undefined, 2) }}</pre></td>
        </tr>
    </table>
</template>

<script>
    import { adminService } from '@/services/admin.service'

    export default {
        name: 'AdminAuditLogList',
        props: [ 'attrs' ],
        data: function() {
            return {
                listing: [],
            };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                adminService.auditLogGet(this.attrs).then((data) => {
                    this.listing = data;
                }).catch((err) => {
                    console.error('Unable to get audit log: ', err)
                });
            },
            cleanData: function(d) {
                return d;
            },
            show: function(al) {
                al.show = 1;
                console.log(al);
            },
            hide: function(al) {
                al.show = 0;
            }
        }
    }
</script>
